import { createContext, useState } from "react"

export let Edit_context = createContext(false);

export default function Edited_context({children}) {
  let [Edited,setEdited] = useState({etat:false,id:'-1'});
  let values = {...Edited,setEdited};
  return (
    <Edit_context.Provider value={values}>
        {children}
    </Edit_context.Provider>
  )
}
